import makeStyles from "@mui/styles/makeStyles";

import { theme } from "../../../App";
const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    height: "100vh",
    alignItems: "center",
    color: "#333333",
    textAlign: "center",
  },
  surveyTheme: {
    marginTop: 56,
    display: "flex",
    justifyContent: "center",
    width: 154,
    height: 154,
  },
  title: {
    fontSize: 34,
    marginTop: 32,
    [theme.breakpoints.up("sm")]: {
      fontSize: 60,
      marginTop: 80,
    },
  },
  description: {
    fontSize: 16,
    marginTop: 16,
    [theme.breakpoints.up("sm")]: {
      fontSize: 24,
      marginTop: 40,
    },
  },
}));

export default useStyles;
